'use client';

import { ReactNode } from 'react';
import { UserRole } from '@/types/auth';
import { usePermissionContext } from './PermissionProvider';

interface RequireRoleProps {
  roles: UserRole[];
  children: ReactNode;
  fallback?: ReactNode;
}

/**
 * Renders `children` only if the current user has one of `roles` (via the existing
 * usePermission()/PermissionProvider stack). Use around individual destructive actions
 * (delete/refund buttons, role-update controls) rather than whole pages, so Viewer/Operator
 * roles keep read access.
 */
export function RequireRole({ roles, children, fallback = null }: RequireRoleProps) {
  const { canView } = usePermissionContext();
  return canView({ roles }) ? <>{children}</> : <>{fallback}</>;
}
